// Code generated by frontend/scripts/generate-element-docs.mjs. DO NOT EDIT.
//
// The search-param surface of Map Publishing's embed, read from the EmbedSearch type
// that @mountaya/studio publishes. The tag schema and the renderer's props were
// both hand-written restatements of it, and had already fallen two params behind.
// Regenerate with:
//
//   node frontend/scripts/generate-element-docs.mjs

/**
 * EMBED_TAG_ATTRIBUTES is the {% map-embedding %} attribute map. Every param the embed
 * route reads is accepted; the frame's own props (height, title) are added by the tag.
 */
export const EMBED_TAG_ATTRIBUTES: Record<string, { type: unknown }> = {
  activity: { type: String },
  bearing: { type: Number },
  center: { type: String },
  collection_id: { type: String },
  enrichments: { type: Array },
  itinerary_id: { type: String },
  overlay: { type: String },
  pitch: { type: Number },
  preferred_language: { type: String },
  preferred_theme: { type: String },
  preferred_unit_length: { type: String },
  preferred_unit_pace: { type: String },
  preferred_unit_slope: { type: String },
  preferred_unit_temperature: { type: String },
  publishable_key: { type: String },
  segments_color: { type: String },
  session_token: { type: String },
  terrain: { type: String },
  terrain_variant: { type: String },
  time_offset: { type: Number },
  with_directions_control: { type: Boolean },
  with_download_control: { type: Boolean },
  with_navigation_control: { type: Boolean },
  with_overlays: { type: Array },
  with_overlays_control: { type: Boolean },
  with_preferences_control: { type: Boolean },
  with_profile_analysis: { type: Boolean },
  with_profile_characteristics: { type: Boolean },
  with_profile_elevation: { type: Boolean },
  with_profile_pace_control: { type: Boolean },
  with_streetview_control: { type: Boolean },
  with_terrains: { type: Array },
  zoom: { type: Number },
};

/**
 * EmbedParams are the search params of Map Publishing's embed as a props shape. The renderer
 * extends it with the props that frame the iframe rather than configure the embed.
 */
export interface EmbedParams {
  activity?: string;
  bearing?: number;
  center?: string;
  collection_id?: string;
  enrichments?: string[];
  itinerary_id?: string;
  overlay?: string;
  pitch?: number;
  preferred_language?: string;
  preferred_theme?: string;
  preferred_unit_length?: string;
  preferred_unit_pace?: string;
  preferred_unit_slope?: string;
  preferred_unit_temperature?: string;
  publishable_key?: string;
  segments_color?: string;
  session_token?: string;
  terrain?: string;
  terrain_variant?: string;
  time_offset?: number;
  with_directions_control?: boolean;
  with_download_control?: boolean;
  with_navigation_control?: boolean;
  with_overlays?: string[];
  with_overlays_control?: boolean;
  with_preferences_control?: boolean;
  with_profile_analysis?: boolean;
  with_profile_characteristics?: boolean;
  with_profile_elevation?: boolean;
  with_profile_pace_control?: boolean;
  with_streetview_control?: boolean;
  with_terrains?: string[];
  zoom?: number;
}
